module.exports = __webpack_public_path__ + "media/video1-m.a98645cb.mp4";